import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

import { stockKeys } from "./query-keys";

// CLAUDE.md rule 4: type from BE schema, not hand-rolled.
export type CreateSKUBody = components["schemas"]["CreateSKURequest"];

export function useCreateSKU() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (body: CreateSKUBody) => {
      const { data, error } = await apiClient.POST("/v1/sku", { body });
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: stockKeys.all });
    },
  });
}
